import React, { Component, useState }  from 'react';
import axios from "axios";
import $ from "jquery";
import Header from "./Components/Header";
import CsvBoxxComponent from "./Components/CsvBoxxComponent";
import 'react-datepicker/dist/react-datepicker.css'
import {Navigate} from "react-router-dom";
import {th} from "date-fns/locale";
import {toast} from "react-toastify";

export class Upload extends Component{
    state = {
        selectedFile: null,
        redirect: false
    }

    openPage = () => {
        window.location.href = "/add-record";
    }
    
    onDownload = () => {
        const element = document.createElement("a");
        element.href = axios.defaults.baseURL + 'suppliers/download-sample-file';
        element.download = "Supplier-Import-File-Format Template.xlsx";
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }

    // File content to be displayed after
    // file upload is complete

    componentDidMount() {
        axios.get(`suppliers/is-logged-in`)
            .then(response => {
                const authorized = response.data.authorized;
                if(authorized === false) {
                    this.setState({ redirect: true })
                }
                
            })
    }
    
    render() {
        if(this.state.redirect)
        {
            return (<Navigate to="/home"/>)
        }
        else {
            return (
                <>
                    <Header  />




                    <section className="section pb-0" style={{ marginBottom: '130px'}}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb-12 row" >


                                </div>


                                <div className="col-lg-12 mb-12">



                                    <article className="card">


                                        <div className="card-body">
                                            <div className="row col-lg-12 mb-12">
                                                <div className="col-lg-6 mb-12" style={{border:'1px #05aced dashed'}}>
                                                    <h3 style={{marginTop:'10px'}}>
                                                       Import Data
                                                    </h3>
                                                    <h6>Choose an xls before pressing the Upload button</h6>
                                                    <p onClick={this.onDownload} style={{fontSize:"13px", color:"green", cursor:"pointer"}}><i className="fa-solid fa-download" style={{fontSize:"18px"}}></i> Download Sample Import File</p>
                                                    <br/>

                                                    <div id={'CsvBoxComp'} style={{marginBottom: '20px'}}>
                                                        <CsvBoxxComponent />
                                                    </div>
               
                                                </div>
                                                <div className="col-lg-6 mb-12 text-center" style={{border:'1px #05aced dashed', borderLeft:'0px'}} >
                                                    <button className='btn btn-primary' onClick={this.openPage} style={{marginTop:'95px'}}>
                                                        <i className="fa-solid fa-plus"></i> Add Manually
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>



                                <div className="col-12">
                                    <div className="border-bottom border-default"></div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            );
        }
        
    }
}

export default Upload;
